export enum GroupType {
  Admin = 'ADMIN_COMPANY',
  User = 'USER_COMPANY'
}

export class ServiceInfo {
  serviceId: string;
  serviceCode: string;
  serviceName: string;
  createDateTime?: string;
  lastUpdateDateTime?: string;
  selected?: boolean;

  public constructor(init?: Partial<ServiceInfo>) {
    Object.assign(this, init);
  }
}

export class CreateService {
  serviceCode: string;
  serviceName: string;

  public constructor(init?: Partial<CreateService>) {
    Object.assign(this, init);
  }
}

export class UpdateService {
  serviceId: string;
  serviceCode: string;
  serviceName: string;

  public constructor(init?: Partial<UpdateService>) {
    Object.assign(this, init);
  }
}

export class SearchService {
  serviceCode: string;
  serviceName: string;

  public constructor(init?: Partial<SearchService>) {
    Object.assign(this, init);
  }
}

export class UpsertServiceRequireIdentity {
  serviceId: string;
  groupKycId: string;
  identityTypeIds: string[]
  public constructor(init?: Partial<UpsertServiceRequireIdentity>) {
    Object.assign(this, init);
  }
}

export class ServiceRequireIdentityDto {
  id: string;
  serviceId: string;
  serviceCode: string;
  serviceName: string;
  identityTypeId: string;
  identityTypeCode: string;
  identityTypeName: string;
  selected?: boolean;
  disable?: boolean;

  public constructor(init?: Partial<ServiceRequireIdentityDto>) {
    Object.assign(this, init);
  }
}

export class ServiceRequireGroupKycDto { 
  groupKycId: string;
  serviceId: string; 

  public constructor(init?: Partial<ServiceRequireIdentityDto>) {
    Object.assign(this, init);
  }
}

export class GetServiceRequireIdentity {
  serviceId: string;

  public constructor(init?: Partial<GetServiceRequireIdentity>) {
    Object.assign(this, init);
  }
}

export class ServiceRequireRoleDto {
  id: string;
  serviceId: string;
  serviceCode: string;
  serviceName: string;
  roleId: number;
  roleName: string;
  registerType: number;
  groupType?: GroupType;

  public constructor(init?: Partial<ServiceRequireRoleDto>) {
    Object.assign(this, init);
  }
}

export class GetServiceRequireRole {
  serviceId: string;

  public constructor(init?: Partial<GetServiceRequireRole>) {
    Object.assign(this, init);
  }
}

export class CheckCompanyCanUserServiceRequest {
  cpid: string;
  serviceId: string;

  public constructor(init?: Partial<CheckCompanyCanUserServiceRequest>) {
    Object.assign(this, init);
  }
}

export class SearchCompanyCanUserServiceRequest {
  cpid: string;
  serviceId: string;

  public constructor(init?: Partial<SearchCompanyCanUserServiceRequest>) {
    Object.assign(this, init);
  }
}

export class ResultCheckCompanyCanUserService {
  can: boolean;
  requireIdentityTypeIdList: string[];
  selfService:boolean;

  public constructor(init?: Partial<ResultCheckCompanyCanUserService>) {
    Object.assign(this, init);
  }
}

export class UpsertCompanyCanUseService {
  cpid: string;
  serviceIdList: string[];

  public constructor(init?: Partial<UpsertCompanyCanUseService>) {
    Object.assign(this, init);
  }
}

export class CompanyCanUseServiceDto {
  id: string;
  cpid: string;
  companyName: string;
  serviceId: string;
  serviceName: string;


  public constructor(init?: Partial<CompanyCanUseServiceDto>) {
    Object.assign(this, init);
  }
}

export class ServiceRequireRoleRequest {
  serviceId: string;
  roleId: string;
  registerType: string;
  groupType?: GroupType;
}

export class UpsertServiceRequireRole {
  data: ServiceRequireRoleRequest[];  

  public constructor(init?: Partial<UpsertServiceRequireRole>) {
    Object.assign(this, init);
  }
}
